import { convertToObjById } from "helpers/convertToObject"

export const LOAD_BRANDS_NEW = 'LOAD_BRANDS_NEW' 
export const SET_BRANDS_NEW = 'SET_BRANDS_NEW' 
export const LOAD_BRANDS_NAMES_V2 = 'LOAD_BRANDS_NAMES_V2' 
export const SET_BRANDS_NAMES_V2 = 'SET_BRANDS_NAMES_V2' 
export const LOAD_BRANDS_SALES_V2 = 'LOAD_BRANDS_SALES_V2' 
export const SET_BRANDS_SALES_V2 = 'SET_BRANDS_SALES_V2' 
export const SET_BRANDS_STATIONS_V2 = 'SET_BRANDS_STATIONS_V2' 
export const ADD_NEW_BRAND_V2 = 'ADD_NEW_BRAND_V2' 
export const EDIT_BRAND_NAME_V2 = 'EDIT_BRAND_NAME_V2' 
export const SET_BRANDS_COMPANY = 'SET_BRANDS_COMPANY' 
export const SET_BRANDS_STATION = 'SET_BRANDS_STATION' 
export const SET_BRANDS_SNACKBAR = 'SET_BRANDS_SNACKBAR' 
export const NEW_BRAND_STATION = 'NEW_BRAND_STATION' 
export const EDIT_BRAND_STATION_V2 = 'EDIT_BRAND_STATION_V2' 
export const NEW_BRAND_SALE_V2 = 'NEW_BRAND_SALE_V2' 
export const EDIT_BRAND_SALE_V2 = 'EDIT_BRAND_SALE_V2' 
export const GET_LOGO = "GET_LOGO";
export const CLEAR_LOGO_LIST = "CLEAR_LOGO_LIST";


const initialState = {
  loading: false,
  brands: {},
  company: {},
  station: {},
  brandName: {},
  brandSales: {},
  logos: [],
  brandSnackbar: {
    active: false,
    brandMsj: '',
    color: ''
  }
}
export const brandsReducerV2 = (state = initialState, { payload, type }) => {
  switch (type) {

    case SET_BRANDS_COMPANY:
      return {
        ...state,
        company: payload
      }
    
      case SET_BRANDS_STATION:
        return {
          ...state,
          station: payload
        }
    case LOAD_BRANDS_NEW:
      return {
        ...state,
        loading: true
      }
    
    case SET_BRANDS_NEW:
      const addingBrandsLabel = payload.map(brand => {
        return {
          ...brand,
          value: brand.id,
          label: `${brand.name} - ${brand.alias}`
        }
      })
      const brands = convertToObjById(addingBrandsLabel)
      return {
        ...state,
        brands
      }

    case SET_BRANDS_NAMES_V2:
      const addingNamesLabel = payload.map(brand => {
        return {
          ...brand,
          value: brand.id,
          label: brand.name,
        }
      })
      const brandName = convertToObjById(addingNamesLabel)
      return {
        ...state,
        brandName
      }

    case EDIT_BRAND_NAME_V2:
      const stringy = JSON.stringify(state)
      let newState = JSON.parse(stringy)
      const editBrand = {
        label: payload.name,
        value: payload.id,
        ...payload,
      }
      state.brandName[payload.id] = editBrand
      return {
        ...newState,
        brandName: {
          ...newState.brandName,
          [payload.id]: editBrand,
        }
        }
    
    case SET_BRANDS_SALES_V2: 
    const addingSalesLabel = payload.map(brand => {
      return {
        ...brand,
        brandName: state.brandName[brand.idBrand]?.name,
        value: brand.id,
        label: brand.name,
      }
    })
    const brandSales = convertToObjById(addingSalesLabel)
    
    return {
      ...state,
      brandSales: brandSales
    }

    case ADD_NEW_BRAND_V2:    
    const byStation = JSON.stringify(state)
    let newStateAdd = JSON.parse(byStation) 
    const newBrand = {
        ...payload,
        label: payload.name,
        value: payload.id,
      }

      return {
        ...newStateAdd,
        brandName: {
          ...newStateAdd.brandName,
          [payload.id]: newBrand,
        }
      }
    
      case SET_BRANDS_SNACKBAR:
        return {
          ...state,
          brandSnackbar: {

          }
        }
      case NEW_BRAND_STATION:
        const newBrandStation = {
          ...payload,
          label: payload.name,
          value: payload.id
        }

        return {
          ...state,
          brands: {
            ...state.brands,
            [payload.id]: newBrandStation,
          }
        }
      case EDIT_BRAND_STATION_V2:
        
          return {
            ...state,
            brands: {
              ...state.brands,
              [payload.id]: {
                label: payload.name,
                value: payload.id,
                ...payload,
                add: true
              },
            }
          }
      case NEW_BRAND_SALE_V2:
      
        return {
          ...state,
          brandSales: {
            ...state.brandSales,
            [payload.id]: {
              ...payload,
              label: payload.name,
              value: payload.id,
              brandName: state.brandName[payload.idBrand]?.name,
            },
          }
        }

      case EDIT_BRAND_SALE_V2:
        

          return {
            ...state,
            brandSales: {
              ...state.brandSales,
              [payload.id]: {
                value: payload.id,
                brandName: state.brandName[payload.idBrand]?.name,
                ...payload,
              },
            }
          }
      case GET_LOGO:
        const ListLogos = payload.addLogos ? [...state.logos, ...payload.logos] : payload.logos
        return {
          ...state,
          logos: ListLogos
        }
      case CLEAR_LOGO_LIST:
        return {
          ...state,
          logos: []
        }
    default: return state
  }

}